<template>
    <div>            
        <p v-if="questions.length < 1">Currently you have no questions waiting to be answered!</p>
        <div v-bind:key="question.id" v-for="question in questions">
            <QuestionItem v-bind:question="question" v-on:del-question="$emit('del-question', question.qid)"/>
        </div>
    </div>
</template>

<script>
    import QuestionItem from './QuestionItem';

    export default {
        name: "Questions",
        components: {
            QuestionItem
        },
        props: ["questions"]
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
